<template>
	<div class="flex-centerize" :class="{ 'visibility-hidden': numOfComments === 0 }">
		<span>{{ numOfComments }} <SIcon name="bubble-msg" class="ml-1" /></span>
	</div>
</template>

<script>
import { useNumOfCommentsOfIdea } from '@/store/modules/inspirationCenter/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'IdeasCommentsCounter',
	props: { ideaId: { type: String } },
	computed: {
		...mapGettersShorthand({ useNumOfCommentsOfIdea }),
		numOfComments() {
			return this.useNumOfCommentsOfIdea(this.ideaId);
		},
	},
};
</script>

<style scoped lang="scss">
span {
	font-size: 14px;
}
</style>
